import { HttpClient } from "@angular/common/http";
import { LocalDataSource, ServerDataSource } from "ng2-smart-table";

export class SpringServerDataSource extends ServerDataSource {

    constructor(http: HttpClient, conf: any, private flattener?: (data: any) => any) {
      super(http, conf);
    }
  
    protected addPagerRequestParams(params: any): any {
  
      if (this.pagingConf && this.pagingConf['page']) {
        params = params.set(
          this.conf.pagerPageKey,
          this.pagingConf['page'] - 1   // convert 1-based → 0-based
        );
      }
  
      if (this.pagingConf && this.pagingConf['perPage']) {
        params = params.set(
          this.conf.pagerLimitKey,
          this.pagingConf['perPage']
        );
      }
  
      return params;
    }

    protected extractDataFromResponse(res: any): any[] {
      const response = res.body ? res.body : res;

      if (this.flattener) {
        this.flattener(response);
      }

      if (this.conf.dataKey) {
        return response[this.conf.dataKey];  // ✅ FIX
      }

      return response;
    }

    /*protected extractDataFromResponse(res: any): Array<any> {

      // Case 1: Spring Pageable response
      if (res && Array.isArray(res.content) && res.totalElements !== undefined) {
        console.log("Paginated response");

        this['lastRequestCount'] = res.totalElements;
        return res.content;
      }

      // Case 2: Non-paginated array
      if (Array.isArray(res)) {
        console.log("Non-paginated array");

        this['lastRequestCount'] = res.length;
        return res;
      }

      // Case 3: Non-paginated single object
      if (res && typeof res === 'object' && res.totalElements === undefined) {
        console.log("Non-paginated single object");

        this['lastRequestCount'] = 1;
        return [res.body];
      }

      // Case 3: paginated single object
      if (res && typeof res === 'object' && res.totalElements !== undefined) {
        console.log("paginated single object");

        this['lastRequestCount'] = 1;
        return [res];
      }

      return [];
    }*/
  
  }